import { render, staticRenderFns } from "./mjywlList.vue?vue&type=template&id=5fcfbfee&scoped=true&"
import script from "./mjywlList.vue?vue&type=script&lang=js&"
export * from "./mjywlList.vue?vue&type=script&lang=js&"
import style0 from "./mjywlList.vue?vue&type=style&index=0&id=5fcfbfee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcfbfee",
  null
  
)

export default component.exports